/***************/
/**  IMPORTS  **/
/***************/
import { useState } from "react";
import { Form, Button, InputGroup } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { FaEyeSlash, FaEye } from "react-icons/fa";
import { orbit } from 'ldrs';
import Cookies from "universal-cookie";

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/
import { Amplify } from 'aws-amplify';
import amplifyconfig from '../amplifyconfiguration.json';
import { post } from 'aws-amplify/api';

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import "../App.css";
import Navbar from "../components/Navbar";
import { FormContainer, 
         AppFormContainer,
         ErrorMessage } from "../styles/RegisterStyles";

/**
 * This component is responsible for displaying the Registration Page
 * @returns The Registration Page
 */
export default function Register() {

    const [first_name, setFirstName] = useState("");
    const [last_name, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [inputType, setInputType] = useState('password');
    const [goToLogin, setGoToLogin] = useState(false);
    const [registerError, setRegisterError] = useState(null);

    const navigate = useNavigate();

    Amplify.configure(amplifyconfig);

    orbit.register();

    const cookies = new Cookies();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const passwordRegex = /^(?=.*[A-Z])(?=.*\d).{8,}$/;
        if (!password && !email) {
            setLoading(false);
            setRegisterError("Fields cannot be empty.");
        } else if (!email) {
            setLoading(false);
            setRegisterError("Email field cannot be empty.");
        } else if (!password) {
            setLoading(false);
            setRegisterError("Password field cannot be empty.");
        } else if (!emailRegex.test(email)) {
            setLoading(false);
            setRegisterError("Please enter a valid email address.");
        } else if (!passwordRegex.test(password)) {
            setLoading(false);
            setRegisterError("Password must:\n Be at least 8 characters long\n Contain at least one capital letter\n Contain at least one number.");
        } else {
            try {
                const register = post({
                    apiName: 'UserAPI',
                    path: '/user/register',
                    options: {
                        body: {
                            first_name,
                            last_name,
                            email,
                            password,
                        }
                    }
                });
    
                const { body } = await register.response;
                const res = await body.json();
                console.log('Registeration POST call succeeded');
                setLoading(false);
                loginHandler();
                goToConsentHandler();
                localStorage.setItem("EMAIL", email);
            } catch (e) {
                console.log('Registration POST call failed: ', e);
                if (e.message === "Error: Email already exists."){
                    setRegisterError("This email already exists. Please go to login.")
                }
                setLoading(false);
            }
        }
    }

    /**  HANDLES GOING TO THE LOGIN PAGE  **/
    const loginHandler = async () => {
        try {
            const loggedIn = post({
                apiName: 'UserAPI',
                path: `/user/login`,
                options: {
                    body: {
                        email,
                        password,
                    }
                }
            });

            const { body } = await loggedIn.response;
            const res = await body.json();
            console.log('Login POST call succeeded');
            cookies.set("TOKEN", res.token, {
                path: '/',
            })
            setLoading(false);
            localStorage.setItem("EMAIL", email);
        } catch (e) {
            console.log('Login POST call failed: ', e);
            setLoading(false);
        }
    }

    /**  HANDLES SHOWING THE PASSWORD  **/
    const clickHandler = () => {
        setShowPass((prev) => !prev);
        setInputType(prevType => (prevType === 'password' ? 'text' : 'password'));
      };

    /**  HANDLES GOING TO THE CONSENT PAGE  **/
    const goToConsentHandler = () => {
        navigate("/consent");
    }

    const goToLoginHandler = () => {
        navigate("/");
    }

    return (
        <>
        <Navbar />
            <AppFormContainer>
                <FormContainer style={{margin: "20px"}}>
                    <div className='form-style'>
                        <h2>Register</h2>
                            <Form>
                                {/* first name */}
                                <Form.Group controlId="formBasicFirstName">
                                    <Form.Label>First Name<span style={{color: "red"}}>*</span></Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    name="first_name"
                                    value={first_name}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    placeholder="First Name"
                                    required />
                                </Form.Group>
                                <br />
                                {/* last name */}
                                <Form.Group controlId="formBasicLastName">
                                    <Form.Label>Last Name<span style={{color: "red"}}>*</span></Form.Label>
                                    <InputGroup>
                                        <Form.Control 
                                        type="text"
                                        name="last_name"
                                        value={last_name}
                                        onChange={(e) => setLastName(e.target.value)}
                                        placeholder="Last Name"
                                        required />
                                    </InputGroup>
                                </Form.Group>
                                <br />
                                {/* email */}
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Email address<span style={{color: "red"}}>*</span></Form.Label>
                                    <Form.Control 
                                    type="email" 
                                    name="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter email"
                                    required />
                                </Form.Group>
                                <br />
                                {/* password */}
                                <Form.Group controlId="formBasicPassword">
                                    <Form.Label>Password<span style={{color: "red"}}>*</span></Form.Label>
                                    <InputGroup>
                                        <Form.Control 
                                        type={inputType}
                                        name="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Password"
                                        required />
                                        <InputGroup.Text onClick={clickHandler}>
                                            {showPass ? <FaEye /> : <FaEyeSlash />}
                                            </InputGroup.Text>
                                    </InputGroup>
                                </Form.Group>
                                <br />
                                {/* submit button */}
                                <div className='button-style'>
                                    <Button 
                                    variant="primary" 
                                    type="submit"
                                    onClick={(e) => handleSubmit(e)
                                    }>
                                        { loading ? 
                                                <l-orbit 
                                                    size="30"
                                                    speed="1.5"
                                                    color="#FFFFFF">
                                                </l-orbit> : "Continue" }
                                    </Button>
                                </div>
                                {registerError ? (
                                    <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
                                        <ErrorMessage>
                                            {registerError.split('\n').map((line, index) => (
                                                <p key={index} style={{height: "5px", display: "flex", justifyContent: "flex-start"}}>{line}</p>
                                            ))}
                                        </ErrorMessage>
                                    </div>
                                ) : (
                                    <></>
                                )}
                                <div className='form-style' style={{textAlign: "center", marginTop: "40px", fontSize: "12px"}}>
                                    <div>
                                    Have an Account?
                                    </div>
                                    <Button 
                                    variant="primary" 
                                    type="submit"
                                    onClick={goToLoginHandler}
                                    style={{fontSize: "12px"}}>
                                        Login
                                    </Button>
                                </div>
                            </Form> 
                        </div>
                </FormContainer>
            </AppFormContainer>
        </>
    )
}
